<template>
  <div class="max-w-[105px] shrink-0 min-w-[105px] max-h-[40px] flex items-center rounded-sm bg-yellow-400 border border-stone-950 overflow-hidden">
    <div class="flex">
        <div class="flex flex-col px-[2px] py-[2px] align-center justify-center border-l border-stone-950">
            <span class="text-xxxs">ایران</span>
            <span class="text-xxs">{{ numIr }}</span>
        </div>
        <div class="space-c space-x-1 space-x-reverse flex align-center mr-1">
            <span>{{ numLeft }}</span>
            <span>{{ letter }}</span>
            <span>{{ numRight }}</span>
        </div>
        <div dir="ltr" class="bg-blue-800 text-white flex pl-1 justify-center flex-col py-[2px] mr-1">
            <img class="w-[10px]" src="../assets/iran.png" alt="">
            <!-- <span class="text-xxxs -mb-1">IR</span> -->
            <span class="text-xxxs">Iran</span>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Plaque',
    props: ['plaque'],
    data() {
        return {
            numIr: '',
            numRight: '',
            numLeft: '',
            letter: '',
        }
    },
    methods: {
        setPlaqueInUi(){
            if ( this.plaque && !this.plaque?.id ) {
                let splited = this.plaque.split('').filter(i => i !== ' ' && i)
                let letterIndex = splited.findIndex(i => isNaN(i) && i) 
                this.letter = splited.splice(letterIndex , 1).join('')
                this.numRight = splited.splice(0,2).join('')
                this.numIr = splited.slice(splited.length-2).join('')
                this.numLeft = splited.slice(0, 3).join('')
            } else if(this.plaque) {
                this.numIr = this.plaque.shomare_serial_plaque
                this.numLeft = this.plaque.plq1
                this.letter = this.plaque.plq2
                this.numRight = this.plaque.plq3
            }
        }
    },
    mounted() {
        this.setPlaqueInUi()
    },
}
</script>

<style scoped>
.space-c span{
    letter-spacing: 2px;
    font-size: 10px;
}
.text-xxs{
    font-size: 10px !important;
}
span{
    line-height: 1.5 !important;
}
.text-xxxs{
    font-size: 6px !important;
}
</style>